<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2022-11-01 09:55:17
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectPublicity\ProjectPublicityList.vue
 * @Description: 
 */
 -->

 <template>
  <div class="satisfaction-rate-list">
    <div class="search-box" :class="{ 'show': showList }">
      <van-search 
        v-model="searchValue" placeholder="搜索项目名称" show-action
        @search="search" @cancel="onCancel" @focus="showSearch=true" 
      />
    </div>
    <div class="satisfaction-rate-list-box">
      <no-data v-if="list.length == 0"></no-data>
      <van-pull-refresh class="refresh-box" v-model="refreshConfig.refreshing" @refresh="onRefresh">
        <van-list
          class="job-list"
          v-model="refreshConfig.loading"
          :finished="refreshConfig.finished"
          :finished-text="refreshConfig.finishedText"
          :error.sync="refreshConfig.error"
          :error-text="refreshConfig.errorText"
          @load="onLoad"
        >
          <div class="list">
            <div class="list-item" v-for="(item, i) in list" :key="i">
              <div class="top">
                <img src="@/assets/img/opinionPublish/home_icon.png">
                <div class="title">{{ item.gcmc }}</div>
              </div>
              <div class="middle">
                <div class="info">
                  <div class="label">项目代码</div>
                  <div class="value">{{ item.gcbh }}</div>
                </div>
                <div class="info">
                  <div class="label">建设单位</div>
                  <div class="value">{{ item.jsdw }}</div>
                </div>
                <div class="info">
                  <div class="label">项目地点</div>
                  <div class="value">{{ item.gcxxdd }}</div>
                </div>
              </div>
              <div class="bottom" @click="checkDetail(item)">
                <span>详情</span>
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from '@/utils/api/projectPublicity.api.js'
import commonApi from '@/utils/api/common'
import moduleMixins from '@/mixins/moduleMixins'
import listMixins from '@/mixins/comListMixins'
export default {
  name: 'SatisfactionRateList',
  mixins: [listMixins, moduleMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      showSearch: false,
      showList: false,
      selected: 0,
      searchValue: '', // 搜索条件
      list: [],
      columns: [], // 列表子项的左侧标题数组
      loading: false,
      finished: false,
      unitLevel: '',
      show: true,
      toNext: false,
      title: '满意度评价',
      CLSXArr:[],// 测量事项
      projectCode:[],// 测量事项代码数组
      activeNames:['0'],
      isEnabled: false,// 是否可以编辑评价
      that: this,// filters使用的指针
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.prevent_back()
        } else {
          this.unitLevel = ''
          this.searchValue = ''
          this.remove_back()
        }
      }
    }
  },
  computed: {
    navTitle() {
      return this.$route.query.title
    }
  },
  methods: {
    satisfyListOnload(){
      let params = {
        page: 1,
        rows: 20,
        pageSize: 20,// 接口是用pageSize
        keyword: this.searchValue,
        type: 7,
      }
      this.loadDict()
      this.loadData(params)
    },
    // 加载获取项目公示列表
    loadData(data) {
      // this.loading = true
      let params = {
        page: data.page,
        rows: data.rows,
        key: this.searchValue,
      }
      return api.getMyProject(params).then(res => {
        console.log('--res', res.data.rowsList)
        // this.loading = false
        this.columns = res.data.columns
        if (data.page == 1) {
          this.list = res.data.rowsList
        } else {
          this.list.push(...res.data.rowsList)
        }
        this.finished = this.list.length >= res.data.total
        return Promise.resolve(res)
      })
    },
    checkDetail(data){
      console.log('--详情--', data)
      // this.$router.push({
      //   name: 'ProjectPublicityInfo',
      //   params: data
      // })
      this.$router.push({
        name: 'ProjectPublicityStep',
        params: {
          detailData: data,
        }
      })
    },
    // 满意度评价页
    toEvalate(itm, idx){
      // console.log("toEvalate:",itm);
      // 值为 待完成后评价 只显示字不可点击， 已完成 时可点击查看评价详情【根据获取的满意度维度获取对应的值】，值为 点击评价 时候可点击进行评价【总体评价同理字段：allEvaluat】
      let params = {
        rid: itm.RID,
        YWBH: itm.YWBH,// 业务编号
        CHCGZL:itm.CHCGZL,// 满意度评价--测绘成果质量
        CKFWZL:itm.CKFWZL,// 满意度评价--服务质量
        RYSZ:itm.RYSZ,// 满意度评价--人员素质
        FWPY:itm.FWPY,// 满意度评价--服务评语
        MYDPJ: itm.MYDPJ,// 满意度评价
      }
      // 满意度评价分为总体评价及分项评价
      if(itm.allEvaluat) {
        // 总体评价
        this.isEnabled = itm.allEvaluat == '点击评价' ? true : false// 1.待完成后评价 2.点击评价 3.已完成
        if(itm.MYDPJ == '点击评价' || itm.MYDPJ == '已完成') {
          params.isEnabled = this.isEnabled
        }
      } else {
        // 分项评价
        this.isEnabled = itm.MYDPJ == '点击评价' ? true : false// 1.待完成后评价 2.点击评价 3.已完成
        if(itm.MYDPJ == '点击评价' || itm.MYDPJ == '已完成'){
          params.isEnabled = this.isEnabled // 是否可评价
          params.HJINDEX = itm.HJINDEX // 汇交次数 
          params.CLSX = itm.CLSX // 测量事项
        }
      }
      this.$router.push({
        name:"SatisfactionRate",
        params
      })
    },
    // 搜索测绘作业
    search(val) {
      console.log('搜索值', val)
      this.show = true
      this.searchValue = val
      this.onRefresh()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.showSearch = false
      this.searchValue = ''
      this.onRefresh()
    },
    clickCondition() {
      this.showList = true
    },
    cellSelect(i) {
      this.selected = i
      this.showList = false
    },
    getCLSX(val){
      let projectCodeArr = this.projectCode
      for(let i = 0; i < projectCodeArr.length; i++){
        if(projectCodeArr[i].code == val){
          return projectCodeArr[i].showValue
        }
      }
    },
    loadDict() {
      // 先要判断vuex有没有保存字典
      if (Object.keys(this.$store.state.projectCode).length == 0) {
        commonApi.lookupDict({code: 'CLSX'}).then(res => {
          this.CLSXArr = res.data
          res.data.forEach(element => {
            commonApi.lookupDict({code: element.code}).then(res => {
              console.log('--res: ', res)
              // this.$store.commit('setProjectCode', res.data)
              // this.projectCode = res.data
              this.projectCode = this.projectCode.concat(res.data)
              this.$store.commit('setProjectCode', this.projectCode)
            })
          })
        })
      }
    },
    pushStateFun() {
      if (!this.toNext) {
        this.show = false
      } else {
        this.toNext = false
      }
    },
    prevent_back() {
      let path = this.$route.fullPath
      // 判断是否开启了后端支持
      if (this.$router.mode == 'hash') {
        path = '#' + path
      }
      var state = {
        title: this.navTitle,
        url: path //要禁掉的页面
      }
      window.history.pushState(state, null, path) //要禁掉的页面
      window.addEventListener('popstate', this.pushStateFun, false)
    },
    remove_back() {
      window.removeEventListener('popstate', this.pushStateFun, false)
    }
  },
  filters:{
    getCLSXText(val,that){
      let projectCodeArr = that.projectCode
      for(let i = 0; i < projectCodeArr.length; i++){
        if(projectCodeArr[i].code == val){
          return projectCodeArr[i].showValue
        }
      }
    },
  },
  created() {
    // this.onRefresh()
  },
  mounted() {
    //判断是否有中间页
    this.title = this.$route.query.title
    // this.loadDict();
    this.$bus.$on('satisfyListOnload', () => {
      this.satisfyListOnload()
    })
  },
  activated(){
    this.loadDict()
  },
}
</script>
<style lang="scss" scoped>
.satisfaction-rate-list {
  position: relative;
  height: calc(100vh - 95px);
  .search-box{
    width: 100vw;
    position: fixed;
    z-index: 99;

  }
  .tabs {
    position: fixed;
    top: 45px;
    left: 0px;
    z-index: 9;
  }
  .satisfaction-rate-list-box {
    // height: calc(100vh - 47px);
    background: #f1f3f6;
    // overflow: auto;
    padding: 70px 15px 0;
    box-sizing: border-box;
    .refresh-box{
      z-index: 9;
    }
    .job-list {
      height: 100%;
      .list {
        overflow-y: auto;
        &-item {
          background-color: #fff;
          border-radius: 5px;
          margin-bottom: 20px;
          .top {
            display: flex;
            align-items: center;
            margin: 0 10px;
            border-bottom: 1px solid #F1F3F6;
            img {
              width: 50px;
              padding: 10px;
              padding-left: 0;
            }
            .title {
              font-weight: bold;
            }
          }
          .middle {
            padding: 10px;
            .info {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              font-size: 14px;
              position: relative;
              .label {
                width: 80px;
                color: #999;
              }
              .value {
                flex: 1;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .status {
                margin-right: 1rem;
                padding: 3px 8px;
                color: #333;
                background-color: #ddd;
                &.yellow {
                  color: #D78534;
                  background-color: #FFEBCC;
                }
                &.red {
                  color: #FA6366;
                  background-color: #FFD5D5;
                }
                &.green {
                  color: #34CC8C;
                  background-color: #DCF4EA;
                }
                &.blue {
                  color: #155EDE;
                  background-color: #D5E4FF;
                }
              }
            }
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #F1F3F6;
            padding: 10px;
            i {
              color: #999;
            }
          }
        }
      }
    }
  }
}
</style>
